<div class="row match-height justify-content-center">
    <div class="col-md-7">
        <div class="content-wrapper container-xxl p-0">
            <div class="content-body">
                <app-content-header [contentHeader]="contentHeader"></app-content-header>
            
                <section id="basic-vertical-layouts">
                    <div class="row match-height justify-content-center">
                      <div class="col-md-12 col-12">

                          <div class="card-body">
                            <form class="form form-vertical">
                              <div class="row">
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="first-name-vertical"><h6>Customer Name</h6></label>
                                    <input
                                      type="text"
                                      [(ngModel)]="customer_name"
                                      id="first-name-vertical"
                                      class="form-control"
                                      name="fname"
                                      placeholder="Customer Name"
                                    />
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="email-id-vertical"><h6>Customer Email</h6></label>
                                    <input
                                      type="email"
                                      [(ngModel)]="customer_email"
                                      id="email-id-vertical"
                                      class="form-control"
                                      name="customer_email"
                                      disabled
                                      placeholder="Customer Email"
                                    />
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="contact-info-vertical"><h6>Customer Mobile</h6></label>
                                    <input
                                      type="number"
                                      [(ngModel)]="customer_phone"
                                      id="contact-info-vertical"
                                      name="customer_phone"
                                      class="form-control"
                                      placeholder="Customer Mobile"
                                    />
                                  </div>
                                </div>
                                
                                <div class="col-12">
                                  <button (click)="submitProfile()" *ngIf="disable === false" type="submit" rippleEffect class="btn btn-primary mr-1">Submit</button>
                                  <button *ngIf="disable === true" type="submit" rippleEffect class="btn btn-outline-secondary mr-1">Updating...</button>
                                </div>
                              </div>
                            </form>
                          </div>
                      </div>
                    </div>
                  </section>
    
            </div>
        </div>
    </div>

    <div class="col-md-5">
        <div class="content-wrapper container-xxl p-0">
            <div class="content-body"><br>
                <section id="basic-vertical-layouts">
                    <div class="row match-height justify-content-center">
                      <div class="col-md-12 col-12">
                        <h3 class="card-title">Change Password</h3>

                          <div class="card-body">
                            <form class="form form-vertical">
                              <div class="row">
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="first-name-vertical"><h6>Old Password</h6></label>
                                    <input
                                      type="password"
                                      [(ngModel)]="old_pass"
                                      id="first-name-vertical"
                                      class="form-control"
                                      name="old_pass"
                                      placeholder="Old Password"
                                    />
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="email-id-vertical"><h6>New Password</h6></label>
                                    <input
                                      type="password"
                                      id="email-id-vertical"
                                      class="form-control"
                                      name="new_pass"
                                      [(ngModel)]="new_pass"
                                      placeholder="New Password"
                                    />
                                  </div>
                                </div>
                                <div class="col-12">
                                  <button (click)="submitPassword()" *ngIf="disable_c === false" type="submit" rippleEffect class="btn btn-primary mr-1">Submit</button>
                                  <button *ngIf="disable_c === true" type="submit" rippleEffect class="btn btn-outline-secondary mr-1">Updating...</button>
                                </div>
                              </div>
                            </form>
                          </div>
                      </div>
                    </div>
                  </section>
    
            </div>
        </div>
    </div>
</div>
    